import { Image } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/pro-solid-svg-icons";

import { type NextFlowInfo } from "../../../../types";
import { TextTruncate } from "../../../../../../../../components";
import { PublishStatus } from "components/common/PublishStatus";
import { PublishedStatusTypes } from "../../../../../../../../enums";

import Tooltip from "../../../../../../../../components/common/tooltip/Tooltip";

import styles from "./nextFlowCard.module.scss";
import { HiddenContent } from "components/HiddenContent/HiddenContent";

export interface NextFlowCardProps extends NextFlowInfo {
  isReadOnly: boolean;
  hidden: boolean;
  onChange: () => void;
}

const NextFlowCard = (props: NextFlowCardProps) => {
  const { title, publisher, thumbnailUrl, isReadOnly, onChange, hidden } = props;
  return (
    <div className={styles.root} data-testid="next-flow-card">
      <div className={styles["top-row"]}>
        {!isReadOnly && (
          <div className={styles["edit-icon"]} onClick={onChange} data-testid="edit-icon">
            <FontAwesomeIcon icon={faPencil} />
          </div>
        )}
        <div className={styles.thumbnailContainer}>
          <Image className={styles.thumbnail} src={thumbnailUrl} />
          <HiddenContent isHidden={hidden} variant="card" />
        </div>
        <div className={styles.description}>
          <span className={styles.label}>
            {<Tooltip target={<TextTruncate>{publisher}</TextTruncate>} content={publisher} />}
          </span>
          <Tooltip className={styles.title} target={<TextTruncate lines={2}>{title}</TextTruncate>} content={title} />
        </div>
      </div>
      <div className={styles["bottom-row"]}>
        <PublishStatus publishedStatus={PublishedStatusTypes.published} />
      </div>
    </div>
  );
};

export default NextFlowCard;
